import React, { FC } from 'react';

import Button from '@material-ui/core/Button';

import { SimpleScorcardsIcon } from '../../../../../assets/images';
import { PX } from '../../../../../contrib/ui';

interface IProps {
  toggleScorecardsDrawerOpen: () => void;
}

export const Title: FC<IProps> = props => {
  const { toggleScorecardsDrawerOpen } = props;

  return (
    <div className="title-scorers-container">
      <h2>
        ENTER SCORES
        <div className="css-animation">
          <div className="animation-mask">
            <Button
              aria-label="cancel"
              className="edit-icon"
              color="primary"
              onClick={toggleScorecardsDrawerOpen}
            >
              <img
                src={SimpleScorcardsIcon}
                className="player-header-icon override"
                height={25 * PX}
                width={25 * PX}
                alt="Menu"
              />
            </Button>
          </div>
        </div>
      </h2>
    </div>
  );
};
